import React from 'react';
import { Box } from '@mantine/core';
type RootBoxProps = {
  children: React.ReactNode;
};

export const RootBox = ({ children }: RootBoxProps) => {
  return (
    <Box className="relative z-20 mt-40 flex h-full flex-col xxs:mx-[20px] xxs:max-md:mt-20 md:mx-[120px] lg:mx-[120px] xl:mx-[240px]">
      {children}
    </Box>
  );
};
